import AccountBalanceWalletOutlined from "@mui/icons-material/AccountBalanceWalletOutlined";
import AdminPanelSettingsOutlined from "@mui/icons-material/AdminPanelSettingsOutlined";
import CallSplitOutlined from "@mui/icons-material/CallSplitOutlined";
import CompareArrowsOutlined from "@mui/icons-material/CompareArrowsOutlined";
import DashboardOutlined from "@mui/icons-material/DashboardOutlined";
import HealthAndSafetyOutlined from "@mui/icons-material/HealthAndSafetyOutlined";
import LinkOutlined from "@mui/icons-material/LinkOutlined";
import ShowChartOutlined from "@mui/icons-material/ShowChartOutlined";
import StarBorderOutlined from "@mui/icons-material/StarBorderOutlined";
import type { ReactNode } from "react";

import { routePaths } from "../../routes/route-paths";
import type { TranslationKey } from "../../translations/use-label";

export interface NavigationItem {
  path: string;
  labelKey: TranslationKey;
  icon: ReactNode;
  showPortfolios?: boolean;
}

export interface NavigationGroup {
  groupKey: string;
  items: readonly NavigationItem[];
}

export const navigationGroups: readonly NavigationGroup[] = [
  {
    groupKey: "main",
    items: [
      { path: routePaths.dashboard, labelKey: "navigation.dashboard", icon: <DashboardOutlined /> },
      { path: routePaths.portfolios, labelKey: "navigation.portfolios", icon: <AccountBalanceWalletOutlined />, showPortfolios: true },
      { path: routePaths.portfolioHealth, labelKey: "navigation.portfolioHealth", icon: <HealthAndSafetyOutlined /> },
      { path: routePaths.watchlist, labelKey: "navigation.watchlist", icon: <StarBorderOutlined /> },
      { path: routePaths.instruments, labelKey: "navigation.instruments", icon: <ShowChartOutlined /> },
    ],
  },
  {
    groupKey: "settings",
    items: [
      { path: routePaths.corporateActions, labelKey: "navigation.corporateActions", icon: <CallSplitOutlined /> },
      { path: routePaths.brokers, labelKey: "navigation.brokers", icon: <LinkOutlined /> },
      { path: routePaths.instrumentMapping, labelKey: "navigation.instrumentMapping", icon: <CompareArrowsOutlined /> },
      { path: routePaths.admin, labelKey: "navigation.admin", icon: <AdminPanelSettingsOutlined /> },
    ],
  },
];
